const config = {
  development: {
    API_URL: "" // Empty string means use relative URLs (will hit same domain)
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL || "https://newgo.getarro.app" // Replace with your production API URL
  }
};

const environment = process.env.NODE_ENV || "production";
export const API_URL = config[environment].API_URL;



// WEBPACK FOOTER //
// ./src/urlConfig.js